import React from 'react';
import { Button } from '../ui/button';
import { Lightning, X, SpeakerHigh, SpeakerX } from '@phosphor-icons/react';

/**
 * Persistent header used across every Operator Console view.
 * Subtitle is derived from the active flow + its loaded entity.
 */
export default function OperatorHeader({
  view,
  activePick,
  activeShipOrder,
  activeReceipt,
  activeCount,
  voiceOn,
  toggleVoice,
  onExit,
  skipPack,
  autoPrint,
  printMode,
}) {
  return (
    <div className="flex items-center justify-between px-4 py-2 bg-zinc-950 text-white">
      <div className="flex items-center gap-2">
        <Lightning size={20} weight="fill" className="text-amber-400" />
        <div>
          <h1 className="text-base font-black tracking-tight uppercase leading-none">Operator Console</h1>
          <p className="text-[10px] text-zinc-400 uppercase tracking-wider mt-0.5">
            {view === 'queue' && 'Select an order to start'}
            {view === 'pick' && `Picking · ${activePick?.pick_list_number || ''}`}
            {view === 'ship' && `Shipping · ${activeShipOrder?.order_number || ''}`}
            {view === 'move' && 'Stock Move · scan-driven'}
            {view === 'receive' && `Receiving · ${activeReceipt?.receipt_number || ''}`}
            {view === 'count' && `Cycle Count · ${activeCount?.count_number || ''}`}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="hidden sm:flex items-center gap-2 text-[10px] text-zinc-400">
          {skipPack && <span className="px-1.5 py-0.5 bg-amber-500/20 text-amber-300 font-bold uppercase">Skip-pack</span>}
          {autoPrint && <span className="px-1.5 py-0.5 bg-green-500/20 text-green-300 font-bold uppercase">Auto-print</span>}
          <span className="px-1.5 py-0.5 bg-zinc-800 font-bold uppercase">Print: {printMode}</span>
        </div>
        <Button
          onClick={toggleVoice}
          variant="ghost"
          size="sm"
          className={`text-white hover:bg-zinc-800 h-8 ${voiceOn ? 'text-amber-300' : ''}`}
          data-testid="operator-voice-toggle"
          title={voiceOn ? 'Voice prompts ON · click to mute' : 'Voice prompts OFF · click to enable'}
        >
          {voiceOn ? <SpeakerHigh size={16} weight="fill" /> : <SpeakerX size={16} />}
          <span className="ml-1 hidden md:inline text-[10px] font-bold uppercase">Voice {voiceOn ? 'on' : 'off'}</span>
        </Button>
        <Button onClick={onExit} variant="ghost" size="sm" className="text-white hover:bg-zinc-800 h-8" data-testid="operator-exit-btn">
          <X size={16} className="mr-1" /> Exit
        </Button>
      </div>
    </div>
  );
}
